import 'whatwg-fetch';

export default class StripeInitializer {
  static load(url) {
    return new Promise((resolve, reject) => {
      if (typeof window.stripeObject === 'undefined') {
        if (typeof url === 'undefined') {
          reject(new Error('url was not defined'));
        }
        fetch(url)
          .then((response) => {
            if (!response.ok) {
              throw Error(`Error loading StripeInitializer: url: ${response.url}, status: ${response.status} ${response.statusText}`);
            }
            return response.json();
          })
          .then((json) => {
            resolve(
              (window.stripeObject = window.Stripe(json.key, {
                apiVersion: '2018-11-08' // eslint-disable-line camelcase
              }))
            );
          })
          .catch((error) => {
            if (window.dtrum && typeof window.dtrum.reportError === 'function') {
              window.dtrum.reportError(error);
            }
            reject(error);
          });
      }
    });
  }
}
